import { render } from "./left.vue?vue&type=template&id=58c1e7d5"
const script = {}
script.render = render

export default script